/* eslint-disable quote-props */
"use client";
import Link from "next/link";
import cn from "clsx";
import { useDisabled } from "../form/useDisabled";
import styles from "./button.module.scss";

import * as React from "react";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    size?: "medium" | "small" | "large" | "icon";
    color?: "brand" | "brandDark" | "brandLight" | "yellow" | "white" | "red";
    variant?: "default" | "outlined" | "ghost";
    href?: string;
    target?: string;
    as?: string;
    scroll?: boolean;
    iconLeft?: React.FC<React.SVGProps<SVGSVGElement>>;
    iconRight?: React.FC<React.SVGProps<SVGSVGElement>>;
    loading?: boolean;
    htmlType?: "button" | "submit" | "reset";
  };

export const Button = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ButtonProps
>(
  (
    {
      className,
      color = "brand",
      size = "medium",
      href,
      as,
      loading,
      iconLeft: IconLeft,
      iconRight: IconRight,
      variant = "default",
      children,
      htmlType,
      ...props
    },
    ref,
  ) => {
    const disabled_ = useDisabled();
    const disabled =
      props.disabled === undefined
        ? disabled_ || props.disabled
        : props.disabled;
    const Comp = href ? Link : "button";
    const isIcon = !children;

    return (
      // @ts-ignore
      <Comp
        tabIndex={disabled ? -1 : undefined}
        type={htmlType}
        className={cn(
          styles.button,
          styles[color],
          styles[variant],
          styles[size],
          isIcon ? styles.iconOnly : styles.withText,
          variant !== "outlined" && styles.disabledBorderTransparent,
          isIcon && styles.aspectSquare,
          !isIcon && styles.leadingNone,
          variant === "ghost" ? styles.roundedMd : styles.rounded,
          loading && styles.loading,
          className,
        )}
        href={href as any}
        as={as}
        // scroll={scroll as any}
        ref={ref as any}
        {...props}
        disabled={disabled || loading}
      >
        {IconLeft && (
          <div className={cn(styles.icon, !children && styles.iconOnly)}>
            <IconLeft />
          </div>
        )}
        {children}
        {IconRight && (
          <div className={cn(styles.icon, !children && styles.iconOnly)}>
            <IconRight />
          </div>
        )}
      </Comp>
    );
  },
);
Button.displayName = "Button";
